"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var logInOutDateTime_1 = require("../../common/log-in-out/logInOutDateTime");
var reportStatsCards_styles_1 = require("./reportStatsCards.styles");
var core_components_1 = require("@securityproducts/core-components");
var reportStatsCards_i18n_1 = require("./reportStatsCards.i18n");
exports.ReportStatsCards = function (props) {
    var strings = core_components_1.useLocalisation(reportStatsCards_i18n_1.reportStatsCardsTranslations, props.language);
    return (React.createElement(core_components_1.ErrorBoundary, null,
        React.createElement("div", { className: reportStatsCards_styles_1.container, id: "report-stat-cards" },
            React.createElement("div", { className: reportStatsCards_styles_1.content },
                React.createElement("div", { className: reportStatsCards_styles_1.metric },
                    React.createElement("div", { className: reportStatsCards_styles_1.label },
                        strings.currentStatus,
                        ":"),
                    React.createElement("div", null,
                        React.createElement("div", { id: "status-value" }, strings[props.status]))),
                React.createElement("div", { className: reportStatsCards_styles_1.metric },
                    React.createElement("div", { className: reportStatsCards_styles_1.label },
                        strings.lastLoggedIn,
                        ":"),
                    React.createElement(logInOutDateTime_1.LogInOutDateTime, { id: "last-logged-in", timestamp: props.lastLoggedIn, timezone: props.ianaTimezone, language: props.language, dateOptions: {
                            month: "short",
                            day: "2-digit",
                            year: "numeric",
                        }, timeOptions: { hour: "2-digit", minute: "2-digit" } })),
                React.createElement("div", { className: reportStatsCards_styles_1.metric },
                    React.createElement("div", { className: reportStatsCards_styles_1.label },
                        strings.lastLoggedOut,
                        ":"),
                    React.createElement(logInOutDateTime_1.LogInOutDateTime, { id: "last-logged-out", timestamp: props.lastLoggedOut, timezone: props.ianaTimezone, language: props.language, dateOptions: {
                            month: "short",
                            day: "2-digit",
                            year: "numeric",
                        }, timeOptions: { hour: "2-digit", minute: "2-digit" } }))),
            React.createElement("div", { className: reportStatsCards_styles_1.content },
                React.createElement("div", { className: reportStatsCards_styles_1.metricEmphasis, id: "total-calls" },
                    React.createElement("div", null, strings.totalCalls),
                    React.createElement("div", { className: reportStatsCards_styles_1.emphasis, id: "total-calls-value" }, core_components_1.delimited({ value: props.totalCalls }))),
                React.createElement("div", { className: reportStatsCards_styles_1.metricEmphasis, id: "rolled-calls" },
                    React.createElement("div", null, strings.rolledCalls),
                    React.createElement("div", { className: reportStatsCards_styles_1.emphasis, id: "rolled-calls-value" }, core_components_1.delimited({ value: props.rolledCalls }))),
                React.createElement("div", { className: reportStatsCards_styles_1.metricEmphasis, id: "calls-per-hour" },
                    React.createElement("div", null, strings.callsPerHour),
                    React.createElement("div", { className: reportStatsCards_styles_1.emphasis, id: "calls-per-hour-value" }, core_components_1.delimited({ value: props.callsPerHour })))))));
};
